import React from "react";
import {Box} from '@mui/material';
import CustomAppBar from '../components/appbar';
import MyBidList from "../components/myBids";

const MyBids = () => {
    return (
        <Box>
            <CustomAppBar active="bids"/>
            <MyBidList/>
        </Box>
    );
}

export default MyBids;